import { Routes } from '@angular/router';

export const auditTrailRoutes: Routes = [
  {
    path: 'audit-trail',
    loadComponent: () =>
      import('./audit-trail-list/audit-trail-list').then(
        (m) => m.AuditTrailList,
      ),
  },
];
